export default (value: string | undefined) => {
  if (!value) return null;
  return value?.length > 0 ? value : null;
};
